export default {
  "": "If the loan exceeds the repayment period, your borrowed asset will incur three (3) times the interest during the overdue period. In case of a delay exceeding {'{'}{hour}{'}'} hours, your collateral assets will be liquidated to repay the borrowed amount and interest.",
  "action": "操作",
  "AddLoan": "增加",
  "AdjustLoanFail": "質押資產調整失敗，請重試。",
  "all": "全部",
  "applicationRecords": "申請記錄",
  "apply": "申請",
  "appResultThen": "申請結果。",
  "approvalInProgress": "審核中",
  "assets": "資產",
  "available": "剩餘",
  "availableAssetsNewTips": "可用資產：<span>{num} {token}</span> <a href=\"javascript:;\" class={transferClass} id=\"transfer\">划轉</a>或<a href=\"javascript:;\" class={depositClass} id=\"deposit\">儲值</a>",
  "balance": "可用餘額",
  "BorrowableAmountNewTips": "可借額度：{amount} {coin} 到",
  "borrowAmountNotZero": "借幣數量不可為 0。",
  "borrowingAccount": "借款賬戶",
  "borrowingLimit": "申請借幣上限",
  "botValidateErrCode101": "最小價格太低",
  "botValidateErrCode102": "最小價格太高",
  "botValidateErrCode103": "最大價格太低",
  "botValidateErrCode104": "最大價格太高",
  "botValidateErrCode105": "網格數太少",
  "botValidateErrCode106": "網格數太多",
  "botValidateErrCode107": "投資額太低，未滿足投資要求。",
  "botValidateErrCode108": "投資額太高，大於合約投資上限。",
  "botValidateErrCode109": "止盈價太低",
  "botValidateErrCode110": "止盈價太高",
  "botValidateErrCode111": "止損價太低",
  "botValidateErrCode112": "止損價太高",
  "botValidateErrCode113": "入場價太低",
  "botValidateErrCode114": "入場價太高",
  "cancel": "取消",
  "cancelAll": "撤銷全部",
  "cancelOrder": "撤單",
  "chooseVipCryptoLoans": "選擇 VIP 質押借幣，享受更高借幣上限。現貨或衍生品交易量越高，您可獲得的借幣上限也會越高。",
  "close": "關閉",
  "coin": "幣種",
  "collateralAccount": "抵押賬戶",
  "confirm": "確認",
  "contactOnline": "聯絡客服",
  "contract_account": "合約賬戶",
  "createErrorCode400": "用戶發送的數據包含非法參數。有關更多信息，請查看錯誤消息和錯誤詳情。",
  "createErrorCode401": "餘額不足。",
  "createErrorCode402": "用戶創建的機器人數量已達上限。",
  "createErrorCode403": "服務禁用",
  "createErrorCode404": "所請求資源未找到。",
  "createErrorCode407": "該用戶類型不支持創建機器人子賬戶。",
  "createErrorCode408": "選擇了重複定投標的",
  "createErrorCode409": "最大投資額無效",
  "createErrorCode410": "最大投資額無效",
  "createErrorCode411": "機器人已被關閉",
  "createErrorCode412": "統一保證金賬戶升級中",
  "createErrorCode500": "服務器內部錯誤",
  "createErrorCode501": "內部處理超時",
  "createErrorCode503": "當前定投機器人無法關閉，可能正在進行定投買入。",
  "createTimes": "時間",
  "currency": "幣種",
  "currentOperationFailed": "失敗！請再試一次。",
  "dailyRate": "日利率",
  "dedAccManager": "專屬客戶經理",
  "deposit": "充值",
  "detail": "詳情",
  "direction": "方向",
  "earnSummary": "概述",
  "end": "結束時間",
  "enjoyPersonalizedVipLoan": "選擇 VIP 質押借幣，享受專屬客戶經理服務，以及貼合需求的定製化借款額度和期限。",
  "enterQuantity": "請輸入數量",
  "EstimatedDailyInterest": "預估每日利息",
  "exceedLimitError": "超出平台借幣和抵押上限",
  "exceedPlatformBorrowLimit": "超出平台借幣上限",
  "exceedPlatformLimit": "超出平台抵押上限",
  "expiryDate": "失效日期",
  "failed": "失敗",
  "FAQNewTips": "只要您是 Bybit 註冊用戶且資金賬戶或統一交易賬戶下有質押資產，即可進行借款。",
  "fiat": "法幣",
  "filter": "篩選",
  "firstPage": "首页",
  "fixedRateLoan": "存貸易",
  "fixedRateTerm": "固定利率/期限",
  "from": "開始時間",
  "fullRepaymentAssetReturn": "全額還款後,質押資產將轉回",
  "funding": "資金賬戶",
  "getHightLoanAmount": "解鎖更高額度",
  "global_setting_quick_order_desc": "<p>1. 市價單（快捷下單）</p>\n<p>2. 請注意，填寫的購買數量可能與輸入的訂單數量略有不同。 </p>",
  "global_setting_quick_order_label": "快捷下單",
  "global_setting_title": "自定義設置（適用於現貨）",
  "gotIt": "知道了",
  "hint": "提示",
  "hourlyAnnualIntRate": "小時利率/年利率",
  "HourlyAnnualizedInterestRate": "小時利率/年利率",
  "hoursAmountTips": "最低小時利息為 {amount} {coin}。請注意，系統按小時計息，不足 1 小時按 1 小時計算。",
  "idAuth": "立即認證",
  "iKnow": "我知道了",
  "innovateQuota": "可用額度",
  "inProgress": "進行中",
  "InsufficientAvailableAssetsTips": "可用資產不足，賬戶餘額為 {num} {token}，請進行<a href=\"javascript:;\" class={transferClass} id=\"transfer\">划轉</a>或<a href=\"javascript:;\" class={depositClass} id=\"Deposit\">儲值</a>。",
  "insufficientLendingPoolDemand": "借貸需求旺盛，平台資金池額度不足，還請耐心等待。",
  "interestRatesHourlyYearly": "小時利率/年利率",
  "introUTAUMA": "統一交易賬戶",
  "kline": "K線",
  "lastSixMonthsCommissionRecords": "僅展示最近6個月內的訂單記錄",
  "lendingAnnouncements": "Bybit 餘幣寶與活期儲蓄全面整合 ",
  "leverage": "槓桿倍數",
  "leverage_off_trade_tip": "請開啟槓桿，然後參與槓桿交易。",
  "leverageCloseErrInfo": "操作失敗！您需要還清全部欠款後，才能關閉槓桿交易。",
  "leverageCloseTips": "Failed to disable Margin Trading, as there are active Spot Margin orders in your account.",
  "leverageLoanTips": "操作失敗！您的統一保證金賬戶的 IM 或 MM 佔用率已超過預警值。",
  "leverageTryAgain": "系統異常，請您稍後重試！",
  "limitGreaterNoNeedRequest": "您當前的借幣上限大於本次申請的數量，您無需申請。",
  "liquidate": "已強制平倉",
  "liquidationErrorInfo": "操作失敗！賬戶已觸發強制平倉。",
  "LiquidationPrice": "強平價格",
  "loan": "借款",
  "loan_accont_assets_tip": "賬戶餘額不足",
  "loan_account_tip": "抱歉，您的賬戶存在異常，暫時無法使用質押借幣服務，如有疑問，請聯繫在線客服",
  "loan_agreement": "我已同意<a href={url} target=\"_blank\" class={className}>《借幣條款協議》</a>",
  "loan_all_order": "所有訂單",
  "loan_amount": "可借額度",
  "loan_amount_less_tip": "由於借貸需求過多，平台剩餘可借額度不足，請降低借貸金額或明天再試。",
  "loan_amount_pledge_less_tip": "由於借貸需求過多，平台剩餘可質押額度不足，請降低質押金額或明天再試。",
  "loan_apply": "提交借款申請",
  "loan_apply_time": "借款時間",
  "loan_assets_debt": "資產負債",
  "loan_assets_transfer": "將借入的資產划轉至：",
  "loan_assets_transfer_layer": "借入的資產將划轉至{account}",
  "loan_assets_transfer_tip": "借入的資產將自動划轉至相應賬戶",
  "loan_available_funding_tip": "可用資金賬戶資產：<span>{num} {token}</span> <a href=\"javascript:;\" class={transferClass} id=\"transfer\">划轉</a>或<a href=\"javascript:;\" class={depositClass} id=\"deposit\">儲值</a>",
  "loan_available_funding_tip_new": "資金賬戶可用資產：<span>{num} {token}</span> <a href=\"javascript:;\" class={transferClass} id=\"transfer\">划轉</a>或<a href=\"javascript:;\" class={depositClass} id=\"deposit\">儲值</a>",
  "loan_available_spot_assets": "可用現貨資產",
  "loan_available_spot_less": "可用現貨資產不足，賬戶餘額為 {num} {token}，請進行<a href=\"javascript:;\" class={transferClass} id=\"transfer\">划轉</a>或<a href=\"javascript:;\" class={depositClass} id=\"Deposit\">儲值</a>。",
  "loan_available_spot_tip": "可用現貨資產：<span>{num} {token}</span> <a href=\"javascript:;\" class={transferClass} id=\"transfer\">划轉</a>或<a href=\"javascript:;\" class={depositClass} id=\"deposit\">儲值</a>",
  "loan_available_spot_tip_new": "現貨賬戶可用資產：<span>{num} {token}</span> <a href=\"javascript:;\" class={transferClass} id=\"transfer\">划轉</a>或<a href=\"javascript:;\" class={depositClass} id=\"deposit\">儲值</a>",
  "loan_back_assets": "回款質押資產",
  "loan_borrow_tips": "*借入的資產將划轉至資金賬戶。",
  "loan_confirm_amount": "借款金額",
  "loan_confirm_order": "確認訂單",
  "loan_confirm_tips": "*借入的資產將划轉至資金賬戶。",
  "loan_cope_interest": "應還利息",
  "loan_cope_principal": "應還本金",
  "loan_cope_total": "應還總額",
  "loan_covering_position_tip": "補倉中，無法還款",
  "loan_currency": "借款幣種",
  "loan_debt_assets": "負債資產",
  "loan_debt_total": "總負債金額",
  "loan_edit_pledge_amount": "調整質押金",
  "loan_exceed_pledge_rate_tip": "暫無法借貸，該借貸後將超出追加保證金率",
  "loan_failed": "借款失敗",
  "loan_high_exchange_rate": "高質押率 (LTV)",
  "loan_high_risk": "高風險",
  "loan_hour_day_rate": "小時利率/日利率",
  "loan_hour_day_rate_tip": "最低小時利息為 {precision} {token}。<br />\n\n日利率：{dayRate}<br />\n年利率：{yearRate}<br />\n\n注意：系統按小時計息，不足 1 小時按 1 小時計算。",
  "loan_init_ltv": "初始質押率",
  "loan_init_ltv_tip": "初始 LTV 決定了最初可借入的資產金額，因質押資產而異。",
  "loan_init_ltv_title": "初始質押率 (LTV)",
  "loan_input_amount": "請輸入借款金額",
  "loan_input_pledge_amount": "請輸入質押金額",
  "loan_instant_credit": "即時到賬",
  "loan_interest_accruing": "計息中",
  "loan_interest_accruing_tip": "計息中，無法還款",
  "loan_interest_rate": "利率",
  "loan_interest_time": "計息時間",
  "loan_interest_time_unit": "{num}小時",
  "loan_kyc_tip": "請先完成基礎身份認證，再使用質押借幣服務",
  "loan_limit": "借款期限",
  "loan_limit_day": "{num}天",
  "loan_limit_tip": "利息以實際借款每小時計算利息，可提前還款，逾期後每小時將收取{multiple}倍小時利息，逾期超過{time}小時，您的抵押資產將被清算以償還貸款和利息。",
  "loan_limit_tip_new": "如未能按時還款，逾期期間小時利息將按正常利率的 {num} 倍計算。逾期超過 {hour} 小時後，系統將對您的質押資產進行強平以償還借款本息。",
  "loan_liquidate_ltv": "強平質押率",
  "loan_liquidate_ltv_tip": "如果 LTV（待還本息/質押金額）達到此閾值，系統會對您的質押資產進行強制平倉，以全額償還本金和利息。",
  "loan_liquidate_pledge_tip": "強平中，無法調整質押金",
  "loan_liquidate_tip": "強平中，無法還款",
  "loan_liquidation": "強平中",
  "loan_liquidation_price": "強平價格",
  "loan_login": "登錄後借款",
  "loan_login_tip": "請先 <a href={loginUrl} class={loginClass}>登錄</a> 或 <a href={registerUrl} class={registerClass}>註冊</a>，再使用質押借幣服務。",
  "loan_low_risk": "低風險",
  "loan_lt_user_tip": "注意：借幣成功后，機構借貸 LTV 可能會受到影響。",
  "loan_manual": "手工借款",
  "loan_max_amount": "最高金額：{num} {token}",
  "loan_max_amount_tip": "暫無法借貸，借貸額度已達上限",
  "loan_max_amount_tip2": "您當前 {coin} 的借貸金額已超過用戶的最大借貸額度 {num} {coin}，請降低借貸金額或進行還款。",
  "loan_max_pledge_tip": "暫無法借貸，質押額度已達到上限",
  "loan_max_pledge_tip2": "您當前 {coin} 的質押金額已超過單用戶的最大質押額度 {num} {coin}，請降低質押金額。",
  "loan_middle_risk": "中風險",
  "loan_min_amount": "最低金額：{num} {token}",
  "loan_min_amount_tip": "暫無法借貸，借貸額度低於下限",
  "loan_min_pledge_amount_tip": "暫無法借貸，質押額度低於下限",
  "loan_min_pledge_tip": "最小調整數量為：{num} {token}",
  "loan_no_order_tip": "您當前還沒有借款訂單。立即使用<span>質押借幣</span>服務。",
  "loan_no_pledge_tip": "您當前還沒有借款訂單。立即使用<span>質押借幣</span>服務。",
  "loan_now": "立即開始借幣",
  "loan_order": "借還訂單",
  "loan_order_number": "借款單號",
  "loan_over_capital": "剩餘本金",
  "loan_over_interest": "剩餘利息",
  "loan_overdue": "逾期中",
  "loan_paid_off": "已還清",
  "loan_pledge": "質押借幣",
  "loan_pledge_amount": "質押金額",
  "loan_pledge_assets": "質押資產",
  "loan_pledge_deposit": "質押金",
  "loan_pledge_desc": "質押借幣是指質押一種數字資產借入另外一種數字貨幣，用於交易現貨、衍生品或投入理財以獲取更高收益，也可用於提幣。",
  "loan_pledge_failed": "調整質押率失敗",
  "loan_pledge_processing": "調整質押率處理中",
  "loan_pledge_rate_after": "調整後質押率",
  "loan_pledge_rate_current": "當前質押率",
  "loan_pledge_rate_success": "調整質押率成功",
  "loan_pledge_rate_success_tip": "您成功追加質押金 {num} {token}，調整後質押率為：{rate}",
  "loan_pledge_rate_success_tip1": "質押資產成功減少 {num} {token}，調整後的質押率為 {ltv}",
  "loan_pledge_rate_tip": "質押率 (LTV) 是指借入資產價值與質押資產價值的比率。<br />\n\n初始 LTV：<span class=\"init\">{ltv1}%</span><br />\n初始 LTV 是指最初可借入的資產價值與質押資產價值的比率。<br />\n\n預警 LTV：<span class=\"warning\">{ltv2}%</span><br />\n如果 LTV（待還本息/質押金額）達到此閾值，系統會提醒您追加質押資產。<br />\n\n強平 LTV：<span class=\"liquidate\">{ltv3}%</span><br />\n如果 LTV（待還本息/質押金額）達到此閾值，系統會對您的質押資產進行強制平倉，以全額償還本金和利息。",
  "loan_pledge_total": "總質押金額",
  "loan_pledge_total_amount": "質押總額",
  "loan_process": "借款流程",
  "loan_processing": "借款處理中",
  "loan_progress_order": "進行中訂單",
  "loan_progress_order_qty": "進行中訂單（{num}）",
  "loan_question1_title": "質押借幣需要滿足什麼要求？",
  "loan_question2_detail": "系統按小時計息，根據實際借款時長收取，不足 1 小時按 1 小時計算。\n\n注意：利息根據借款時显示的利率計算得出。\n\n公式：利息 = 借款金額 × 小時利率",
  "loan_question2_title": "利息如何計算？",
  "loan_question3_detail": "Bybit 支持在到期日之前隨時還款，不收取罰金。完成還款后，系統將根據實際借款時長收取利息。",
  "loan_question3_detail2": "只要您是 Bybit 的註冊用戶且現貨賬戶或資金賬戶中有質押資產，即可進行借款。",
  "loan_question3_title": "能否提前全額或部分還款？",
  "loan_question4_detail": "質押率 (LTV) 是指借入資產價值與質押資產價值的比率。\n\n具體計算公式如下：\n\n質押率 = 待還本息/質押金額\n\n待還本息 = (待還本金 + 待還利息 + 待還逾期利息)",
  "loan_question4_title": "質押率是什麼？",
  "loan_question5_content": "您可以在訂單頁面調整質押金。您可以隨時添加更多質押金。",
  "loan_question5_title": "如何調整質押金？",
  "loan_question6_content": "質押借幣可用於包括加密貨幣收益率套利在內的各種高級策略，讓您可以在一個平台以較低利率借入加密貨幣，然後在另一平台以較高利率借出。\n\n<a href={url} target=\"_blank\">點擊此處瞭解詳情</a>。",
  "loan_question6_title": "質押借幣能否用於套利策略？",
  "loan_question7_content": "借入的資產可用於理財產品投資和 DeFi 收益耕作，還可用於槓桿交易，助您增加保證金，避免槓桿倉位遭到強平。\n\n<a href={url} target=\"_blank\">點擊此處瞭解詳情</a>。",
  "loan_question7_title": "如何使用質押借幣服務？",
  "loan_received": "收到借款",
  "loan_repay_account_tip": "全額還款后，質押資產將轉回現貨賬戶。",
  "loan_repay_anytime": "隨時還款",
  "loan_repay_failed": "還款失敗",
  "loan_repay_interest": "還款付息",
  "loan_repay_min_amount": "最小還款數量：{num} {token}",
  "loan_repay_more_tip": "請不要超額還款",
  "loan_repay_processing": "還款處理中",
  "loan_repay_success": "還款成功",
  "loan_repay_success_tip": "您成功還款{num} {token}",
  "loan_repay_time": "應還款時間",
  "loan_repay_time_new": "應還時間",
  "loan_repay_tips": "*全額還款後，質押資產將轉回資金賬戶。",
  "loan_spot_account": "現貨賬戶",
  "loan_spot_assets_not_enough": "可用現貨資產不足，請進行<a href=\"javascript:;\" class={transferClass} id=\"transfer\">划轉</a>或<a href=\"javascript:;\" class={depositClass} id=\"deposit\">儲值</a>。",
  "loan_submember_tip": "子賬戶不支持質押借幣服務",
  "loan_success": "借款成功",
  "loan_success_tip": "您成功借款{num} {token}",
  "loan_total_amount": "借款總額",
  "loan_total_interest": "總利息",
  "loan_total_interest_new": "預估總利息",
  "loan_total_repay": "總還款",
  "loan_total_repayment": "還款總額",
  "loan_total_repayment_new": "預估總還款",
  "loan_type": "借款類型",
  "loan_user_manual": "用戶手冊",
  "loan_uta_tip1": "您已經升級為統一交易賬戶，現貨賬戶功能已遷移至資金賬戶，無法再使用現貨賬戶進行質押借幣。可通過資金賬戶進行質押借幣時，我們將另行通知。",
  "loan_uta_tip2": "統一交易賬戶升級中，暫時無法進行質押借幣。",
  "loan_uta_tip3": "您已經升級為統一交易賬戶，現貨賬戶功能已遷移至資金賬戶，無法再進行質押借幣或調整質押金額。可通過資金賬戶進行質押借幣時，我們將另行通知。",
  "loan_uta_tip4": "統一交易賬戶升級中，暫時無法調整質押金額。",
  "loan_uta_tip5": "統一交易賬戶升級中，暫時無法還款。",
  "loan_valuation": "估值 (單位：{token})",
  "loan_video_btn": "視頻教程",
  "loan_video_title": "質押借幣視頻簡介",
  "loan_want": "我想借款",
  "loan_warning_ltv": "追加保證金率",
  "loan_warning_ltv_tip": "如果 LTV（待還本息/質押金額）達到此閾值，系統會提醒您追加質押資產。",
  "LoanAccountID": "聯繫信息（確保可以聯繫到您）",
  "LoanAccountNumber": "輸入聯繫電話請包含國家代碼。",
  "loanAmount": "借款數量",
  "LoanAmountNew": "可借額度：{amount} {coin}（到{currentAmount}）",
  "LoanAmountNew1": "可借範圍：{minAmount}-{maxAmount} {coin}",
  "LoanAmountNewPledge": "可質押額度：{amount} {coin}（從{currentAmount}<a href=\"javascript:;\" class={transferClass} id=\"transfer\">划轉</a>或<a href=\"javascript:;\" class={depositClass} id=\"Deposit\">儲值</a>）",
  "LoanAmountNewPledge1": "可質押範圍：{minAmount}-{maxAmount} {coin}",
  "LoanEmailTips": "請輸入正確的聯繫方式。",
  "LoanInterestRecords": "利息記錄",
  "LoanInterestRecordsTips": "僅活期質押借幣會提供每小時利息記錄",
  "loanLualityDeposit1": "只有當前質押率小於初始質押率時，方可減少質押資產。",
  "loanLualityDeposit2": "可減少的質押數量上限是達到初始質押率的數量。",
  "loanLualityDeposit3": "若當前質押率大於等於初始質押率，則不允許減少質押資產。",
  "LoanMinAmount": "最低可申購數量：{amount}",
  "LoanMinAmountNew": "最低借款金額：",
  "LoanMinAmountTips": "申購數量需超過最低申購數量。",
  "LoanRateTips1": "活期質押借幣採用小時浮動利率，按實際借款時長每小時計算利息，可提前還款。",
  "loanRecommend": "推薦",
  "loanSureTips": "在確認之前，請先勾選「我同意」複選框",
  "loanTime": "借款時間",
  "loanType": "類型",
  "login": "登錄",
  "ltvAfterBorrowing": "借幣後 LTV",
  "ltvExceedInitial": "借幣後 LTV 不得超過初始質押率 {num1}%。",
  "ltvRatio": "質押借幣數據",
  "marginCallLtvRat": "預警質押率",
  "MARKET": "市場價格",
  "max": "最大",
  "maxBorrowAmount": "借幣上限",
  "maxBorrowingLimit": "最大可申請借幣上限",
  "minHourlyIntRate": "最低小時利息為 0.00000001 USDT。",
  "more": "更多",
  "myLimit": "我的額度",
  "network_error": "請求失敗，請稍後重試。",
  "NEW": "待成交",
  "nextPage": "下一頁",
  "none": "無",
  "noRecords": "暫無記錄",
  "noteSystemCalculates": "注意：系統按小時計息，不足 1 小時按 1 小時計算。",
  "OnlyDepositTransfer": "<a href=\"javascript:;\" class={transferClass} id=\"transfer\">划轉</a>或<a href=\"javascript:;\" class={depositClass} id=\"Deposit\">儲值</a>",
  "onlyVipCanApply": "僅 VIP 用戶才可以申請。",
  "operationSuccess": "成功",
  "or": "或",
  "orderBook": "訂單表",
  "orderHistory": "訂單歷史",
  "orderId": "訂單單號",
  "orderType": "訂單類型",
  "orLoan": "或",
  "otcErrorInfo": "抱歉，您開通了機構借貸，無法進行槓桿交易。",
  "otcFlexible": "活期",
  "other": "其他",
  "outstanding": "待還",
  "pauseTradeTip": "{symbol} 目前暫時無法交易。敬請參閱我們的 <a href=\"{url}\" target=\"_blank\">部落格 </a>，瞭解詳情。",
  "pendingOrderReapply": "有申請中的訂單，請稍後再次申請。",
  "personalizedLoanAmt": "定製額度",
  "pleaseSelect": "請選擇",
  "PledgableLimitNewTips": "可質押額度：{amount} {coin} 從",
  "prevPage": "上一頁",
  "price": "價格",
  "quantity": "數量",
  "reachedAccountLimit": "已達到賬戶限額。",
  "reachedPlatformLimit": "已達到平台限額。",
  "reachOutContactDetails": "我們將在 1 個工作日內透過您提供的聯繫方式與您聯繫。",
  "receivedApplication": "您已成功申請過，稍後可再次申請。",
  "ReduceLoan": "減少",
  "ReduceLoanAssets": "減少質押資產",
  "ReduceLoanAssetsNew": "質押資產可減金額：<span>{num} {token}</span> <a href=\"javascript:;\" class={transferClass} id=\"transfer\">划轉</a>或<a href=\"javascript:;\" class={depositClass} id=\"deposit\">儲值</a>",
  "ReduceLoanTip1": "不能減少質押資產，只有當前質押率小於初始質押率時才能減少質押資產。",
  "ReduceLoanTip2": "不能減少質押資產，減少的數量需小於質押資產可減數量。",
  "ReduceLoanTip3": "不能減少質押資產，減少的數量需小於質押資產可減數量，請重試。",
  "ReduceLoanTip4": "您可以在訂單頁面調整質押金，您可以隨時添加更多質押金，若當前質押率小於初始質押率時，還可以減少質押資產。",
  "reducePledgeAssetsTransferBack": "減少質押資產將轉回至",
  "remainingCollateralLimit": "剩餘抵押額度",
  "remainingLimit": "剩餘借幣額度",
  "repayment": "還款",
  "reset": "重設",
  "resetNew": "重置",
  "result_not_found": "未找到結果",
  "reverse_contract_account": "反向合約賬戶",
  "reviewExpectedTime": "預計 5 分鐘審核完成，屆時請查看 {resultLink}",
  "riskWarning": "確認彈窗",
  "sameLimitDontRepeat": "您當前的借幣上限和本次申請的數量一致，請不要重複申請。",
  "search": "搜尋",
  "searchNew": "搜索",
  "side": "方向",
  "signalStatusExpired": "已過期",
  "sns": "社交媒體平台",
  "spot_account": "現貨賬戶",
  "state": "狀態",
  "status": "狀態",
  "stethTradeTipText": "在质押借币中用作质押资产的 stETH 支持每日生息。",
  "stop_limit": "止盈止損",
  "stop_limit_tips_2": "當前有止盈止損委託單，暫不支持開啟槓桿交易。",
  "submitApplicationLimit": "每天最多可申請 3 次，請明天再試。",
  "submittedSuccessfully": "提交成功",
  "success": "成功",
  "successfully": "成功",
  "sure": "sure",
  "tailoredLoanTerm": "定製期限",
  "thanksForInterestVip": "感謝您對 VIP 質押借幣的支援！",
  "times": "次",
  "timestamp": "時間",
  "title_404": "404 {'|'} Bybit 貨交易  ",
  "to": "至",
  "toastTheSymbolNotExist": "抱歉！您選擇的交易對暫無法訪問",
  "total": "累計",
  "totalInterest": "總利息",
  "tradeDetails": "詳情",
  "tradeId": "成交編號",
  "transfer": "劃轉",
  "uid": "您的賬戶 ID（確保可以聯繫到您）",
  "undefined": "未定義",
  "unifiedAccount": "統一交易賬戶",
  "usdc_contract_account": "USDC 合約賬戶",
  "useMainUidToApply": "請使用主 UID 申請。",
  "variableCannotBeEmpty": "{variable} 不能為空。",
  "vipCryptoLoans": "VIP 質押借幣",
  "vipExclusive": "VIP 專享",
  "vipLoan": "VIP 質押借幣",
  "vipLoan1": "VIP 質押借幣",
  "vipLoanBorrowLimitExpire": "【Bybit】VIP Crypto Loans Borrowing Limit Expiration Notice\n\nHello.\nThe VIP borrowing limit you applied for has expired, if you need to apply again, please also go to VIP Pledge Borrowing Application;\nCoin Type: {'{'}{coin}{'}'}\nRequested amount: {'{'}{num}{'}'} {'{'}{coin}{'}'}\nExpiration date: {'{'}{date}{'}'}\n\n\nBybit Team\nPlease do not reply to system emails.",
  "vipLoanBorrowLimitNotif": "Title \nVIP 質押借幣：借幣上限申請成功 \n\nContent \n尊敬的用戶：\n\n好消息：您提交的借幣上限申請已成功，請儘快使用借幣上限去借款。\n\n申請詳情：\n申請幣種： {'{'}{coin}{'}'} \n申請額度： {'{'}{num}{'}'} {'{'}{coin}{'}'} \n失效日期： {'{'}{date}{'}'} \n\n感謝您選擇 Bybit。\n\n順頌商祺 \nBybit 團隊 \n\n系統郵件，請勿回覆。",
  "vipLoanBorrowLimitRemind": "【Bybit】VIP Crypto Loans Borrowing Limit Expiry Reminder Notice\n\nHello.\nYou have {'{'}{days}{'}'} days left for the VIP borrowing limit you applied for, please use the limit to borrow as soon as possible;\nCurrency applied for: {'{'}{coin}{'}'}\nRequested amount:  {'{'}{num}{'}'}  {'{'}{coin}{'}'}\nExpiration date: {'{'}{date}{'}'}\n\n\nBybit Team\nPlease do not reply to the system email.",
  "vipLowerInterestRate": "VIP 享有更優利率",
  "vipThresholdRights": "點擊此處瞭解 VIP 門檻及專屬權益。",
  "yearlyInterestRate": "年利率",
  "yearlyInterestRateNew": "年化利率"
}